var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pulse-loader',{staticClass:"text-center experto-retail-loader",attrs:{"sm":"12","color":_vm.color}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e699aea","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/expertoRetail/atoms/ExpertoRetailLoader.vue
// module id = 823
// module chunks = 89